import script from "./ProVenue.vue?vue&type=script&setup=true&lang=js"
export * from "./ProVenue.vue?vue&type=script&setup=true&lang=js"

import "./ProVenue.vue?vue&type=style&index=0&id=71d44a3c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71d44a3c"]])

export default __exports__